import React, { Fragment, useEffect, useState } from "react";
import { Bell } from "react-feather";
import { Link } from "react-router-dom";
import { LI, P, UL } from "../../../AbstractElements";
import useAxios from "../../../Utils/useAxios";
import { getMessaging, onMessage } from "firebase/messaging";

const Notifications = () => {
  const axiosInstance = useAxios();
  const [mailList, setMailList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [push, setPush] = useState([]);
  const [pushComing, setPushComing] = useState(false);

  let isMounted = true;
  useEffect(() => {
    // getMailList();
    getModuleList();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (pushComing) {
      // getMailList();
      getModuleList();
      setPushComing(false);
    }
  }, [pushComing]);

  const messaging = getMessaging();
  onMessage(messaging, (payload) => {
    // const receiverList = JSON.parse(payload.data.receiver);
    // const username = localStorage.getItem("username");
    console.log(payload);
    if (payload) {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          new Notification(payload.data.title, {
            body: payload.data.description,
            icon: "",
          });
        }
      });
      setPushComing(true);
    }
  });

  const countUnreadNotifications = () => {
    const initialValue = 0;
    return moduleList?.reduce(
      (result, curr) => (result += curr.count),
      initialValue
    );
  };

  // const getUnreadCountByModule = (moduleId) => {
  //   return mailList.filter(
  //     (notification) =>
  //       notification.notification_object_id.module_type.module_id.module ===
  //         moduleId && !notification.is_read
  //   ).length;
  // };

  // const getMailList = async () => {
  //   await axiosInstance.get("notification/all/").then(function (response) {
  //     if (isMounted && response.status === 200) {
  //       setMailList(response.data);
  //     }
  //   });
  // };

  const getModuleList = async () => {
    await axiosInstance
      .get("notification/modules/count/")
      .then(function (response) {
        if (isMounted && response.status === 200) {
          setModuleList(response.data);
        }
      });
  };

  return (
    <Fragment>
      <LI attrLI={{ className: "onhover-dropdown" }}>
        <div className="notification-box">
          <i>
            <Bell />
          </i>
          <span className="badge rounded-pill badge-primary">
            {countUnreadNotifications()}
          </span>
        </div>
        <div className="notification-dropdown onhover-show-div">
          <UL>
            {moduleList.map((module) => (
              <LI key={module.id}>
                <P attrPara={{ className: "mb-0 p-relative" }}>
                  <Link>{module.module}</Link>
                  <span className="pull-right">
                    {module.count}
                    {/* {getUnreadCountByModule(module.module)} */}
                  </span>
                </P>
              </LI>
            ))}
          </UL>
          <div className="m-3 mt-1">
            <Link
              className="btn btn-light w-100"
              to={`${process.env.PUBLIC_URL}/email/mailbox`}
            >
              View all
            </Link>
          </div>
        </div>
      </LI>
    </Fragment>
  );
};

export default Notifications;
